import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_7b472558";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_7b472558" };
/** script content **/
require("./toast.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex7b472558%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Ftoast%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_7b472558"],
    ctorType: "component",
    outputPath: "components/index7b472558/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-popup': getComponent(require("../popup/index.mpx?isComponent&outputPath=components%2Findex106ca599%2Findex")), 'cube-icon': getComponent(require("../icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
